<template>
   <div class="gens-healthylife">
       <div class="img-ss">
            <img class="gens-img" src="../assets/images/reproductive/test-healthy-life.jpg" />
             <div class="gens-title">
                 <h1 class="gens_title_one">{{$t('ContractText.Health_and_disease_risk')}}</h1>
                 <h4 class="gens_title_two" style="color:#ffffff">{{$t('others.others_52')}}<br>{{$t('others.others_53')}}</h4>
             </div>
       </div>
       <div class="gens_line_height"></div>
       
       <div class="gens_info">
           <div class="gens_content">
               <div class="gens_title"><strong>{{$t('others.others_54')}}</strong></div>
               <div class="gens_description">
                   <div class="description_item">{{$t('others.others_55')}}</div>
                   <div class="description_item">{{$t('others.others_56')}}</div>
               </div>
           </div>
       </div>
       <div class="gens_info gens_info_special">
           <div class="gens_content">
               <div class="gens_title txt_special">
                   <div>{{$t('others.others_57')}}</div>
                   <div>{{$t('others.others_57s')}}</div>
                </div>
               <div class="gens_description txt_special">
                   <div class="description_item txt_special">{{$t('others.others_58')}}</div>
                   <div class="description_item txt_special">{{$t('others.others_59')}}</div>
                   <div class="description_item txt_special">{{$t('others.others_60')}}</div>
               </div>
           </div>
       </div>

       <div class="info_item">
           <div class="item_content_info">
               <div class="item_li">
                   <div class="image_s" id="img_one">
                       <img class="image_style" src="../assets/images/reproductive/Banner_600x300_talent-gene.jpg" />
                   </div>
                   <div class="right_content">
                       <div class="title_c">{{$t('ContractText.Talent_gene_testing')}}</div>
                       <div class="content_d">{{$t('others.others_61')}}</div>
                       <div class="content_d">{{$t('others.others_62')}}</div>
                       <div class="more" @click="liJump('innategene')">
                            {{$t('stdfastces.stdfastces_twenty')}}  <i class="icon iconfont iconxiangyou xiangyou"></i>
                        </div>
                   </div>
                   
               </div>
               
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
            showInfoDetail:false,
        }
    },
    mounted(){
        $(window).scroll(function(){ //滚动某位置 动画特效
            
              
            if($(window).scrollTop() > 1011){
               $('#img_one').addClass('two_transfer');
            }
              
            
        })
    },
    methods:{
         liJump(path){
            this.$router.push({
            path:path
        })
      },
    }
}
</script>

<style lang="scss" scoped>

  @import '../assets/font/iconfont.css';
@import '../assets/css/animation.css';

.gens-healthylife{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    .img-ss{
        position: relative;
        // display: flex;
        overflow: hidden;
        .gens-img{
            max-width: 100%;
            height: auto;
            position: relative;
        }
         .gens-title{
                top:0;
                width: 100%;
                height: 100%;
                font-size: 47px;
                line-height: 60px;
                color: #fff;
                position: absolute;
                padding-left:10%;
                padding-right:10%;
                font-weight: 600;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                flex-direction: column;
                text-align: left;
            .gens_title_one{
                font-size: 37px;
                color: #fff;
                font-weight: 600;
                display:inline-block;
            }
            .gens_title_two{
                font-size: 20px;
                color: #fff;
                display: flex;
                justify-content: left;
                align-items: center;
                text-shadow: 2px 2px 2px rgba(0,0,0,.4);
            }
        }
    }
 
    .gens_line_height{
        height: 17px;
        background:#f1c480;
    }

    .gens_info{
         background-color:#ffffff;
       padding-top:60px;
       padding-bottom:30px;
       .gens_content{
           width:1200px;
           margin:auto;
           display: flex;
           justify-content: flex-start;    
           flex-direction: row;
           flex-wrap: nowrap;
           text-align: left;
           .gens_title{
               width: 28%;
               color:#f1c480;
               font-size:30px;
               text-align: left;
               font-weight: bold;
               margin-bottom:10px;
           }
           .gens_description{
                margin-left:120px;
               
               display: flex;
               justify-content: center;
               align-items: flex-start;
               color: #f1c480;
               flex-direction: column;

                .description_item{
                    color: #f1c480;
                    font-size:18px;
                    font-weight: 600;;
                    text-transform: none;
                    margin-bottom:24px;
                    .item_strong{
                        color:#f1c480;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        text-transform: none;
                    }
                }
            }
        }
    }
    .gens_info_special{
        background-color: rgba(241,196,128,0.7);
        color:#fff;
    }
    .txt_special{
        color:#fff !important;
    }


    .info_item{
       background-color:#ffffff;
       .item_content_info{
           width:100%;
           display: flex;  
           flex-direction: column;
           flex-wrap: wrap;
           .item_li{
               display: flex;
               flex-direction: row;
               
               .image_s{
                    display: inline-block;
                    vertical-align: top;
                    max-width: 100%;
                    text-align: left;
                    height: 100%;
                    opacity: 0;
                   .image_style{
                        height: 100%;
                        max-width: 100%;
                        min-width: 600px;
                   }
               }
               .right_content{
                   display: flex;
                   align-items: flex-start;
                   justify-content: center;
                   flex-direction: column;
                   margin-left:15%;
                   .title_c{
                        color: #368da7;
                        font-size: 28px;
                        font-style: normal;
                        font-weight: 700;
                        text-transform: none;
                        margin-bottom:24px;
                   }
                   .content_d{
                        color: #3a3a3a;
                        font-size: 16px;
                        line-height: 24px;
                        font-style: normal;
                        font-weight: 400;
                        margin-bottom:24px;
                        text-align: left;

                   }
                   .more{
                       cursor: pointer;
                       color: #ffffff;
                        border-color: #f1c480;
                        font-weight: 700;
                        letter-spacing: 2px;
                        border-radius: 0px;
                        -moz-border-radius: 0px;
                        -webkit-border-radius: 0px;
                        background-color: #f1c480;
                        text-align: center;
                         padding:0 23px;
                       .xiangyou{
                           text-align: center;
                            font-size: 14px;
                            line-height: 36px;
                            height: 36px;
                            text-transform: none;
                            border-width: 2px;
                           
                        }
                   }
                   
               }
           }
           .item_li_special{
            background-color:#f5f7f9;
        }
       }
       
    }

    
  

 
  


  
           
}
</style>
<style>


.gens-healthylife{
    margin-top:0 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/healthylife.vue